'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('@brandwatch/axiom-materials/dist/colors');

var _ = _interopRequireWildcard(_colors);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _filter = require('./_filter');

var _filter2 = _interopRequireDefault(_filter);

require('./Candytar.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var availableColors = Object.keys(_.userDefinedGraphColors);
var defaultPickerFn = function defaultPickerFn(colors) {
  return colors[Math.floor(Math.random() * colors.length)];
};

var Candytar = function (_Component) {
  _inherits(Candytar, _Component);

  function Candytar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Candytar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Candytar.__proto__ || Object.getPrototypeOf(Candytar)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = _filter2.default, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Candytar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          picker = _props.picker,
          _props$color = _props.color,
          color = _props$color === undefined ? picker(availableColors) : _props$color,
          size = _props.size,
          initials = _props.initials;

      var style = { height: size, width: size };
      var classes = (0, _classnames2.default)('ax-candytar', 'ax-candytar--' + color);
      var userInitials = initials.slice(0, 2).toUpperCase();

      /* eslint-disable max-len */
      var showSilhouette = _react2.default.createElement('path', {
        className: 'ax-candytar__body',
        d: 'M16 20c-4 0-7-3-7-7s3-7 7-7 7 3 7 7-3 7-7 7zM6 28.5c1.7-3.8 5.6-6.5 10-6.5 4.5 0 8.3 2.7 10 6.5C23.4 30.7 20 32 16 32s-7.3-1.3-10-3.5z',
        filter: 'url(#ax-candytar__filter)' });

      var showInitials = _react2.default.createElement(
        'text',
        { alignmentBaseline: 'middle', className: 'ax-candytar__initials', textAnchor: 'middle', x: '50%', y: '54%' },
        userInitials
      );
      /* eslint-enable max-len */

      return _react2.default.createElement(
        'svg',
        { className: classes, style: style, viewBox: '0 0 32 32' },
        _react2.default.createElement('circle', { className: 'ax-candytar__background', cx: '16', cy: '16', r: '16' }),
        initials ? showInitials : showSilhouette
      );
    }
  }]);

  return Candytar;
}(_react.Component);

Candytar.propTypes = {
  /** Color of the Candytar */
  color: _propTypes2.default.oneOf(['tiny-clanger', 'critical-mass', 'paradise-lost', 'serene-sea', 'giant-leap', 'moon-lagoon', 'terra-form', 'primeval-soup', 'new-horizon', 'blast-off', 'ground-control', 'luna-dust']),
  /**
   * The User's initials to appear in the candytar.
   * If no initials are supplied the silhouette will be shown by default.
   */
  initials: _propTypes2.default.string,
  /**
   * A function that can be passed to determine the colour of the candytar.
   * By default if no colour is provided it will randomly picker a colour
   * from the available options. Given function is called with an array of
   * the available colors.
   */
  picker: _propTypes2.default.func,
  /** Size of the Candytar */
  size: _propTypes2.default.string.isRequired
};
Candytar.defaultProps = {
  picker: defaultPickerFn,
  initials: ''
};
exports.default = Candytar;